/*
 *		Copyright (c) 2011-2015 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */
'use strict';

/* Filters */

angular.module('access.Utils')
    .filter('formatTimeLeft', [
        '$translate',
        function ($translate) {
            return function (seconds) {
                var minutes = Math.round(seconds / 60);

                return (seconds < 60 ? '<' : '') +
                    (minutes > 100 ? '>' : '') +
                    $translate.instant(
                        'minute',
                        { COUNT: Math.max(1, Math.min(100, minutes)) },
                        'messageformat'
                    );
            };
        }
    ])
    .filter('formatTime', function () {
        function _zeroPadded(n) {
            return (n < 10 ? '0' : '') + n;
        }

        return function (inputSeconds) {
            var displaySeconds = inputSeconds % 60,
                displayMinutes = Math.floor(inputSeconds / 60);

            return (_zeroPadded(displayMinutes) + ':' + _zeroPadded(displaySeconds));
        }
    });
